import { Box, Grid, Pagination, Skeleton } from "@mui/material";
import React from "react";
import Carousel from "react-material-ui-carousel";
import useIsSmallScreen from "../../hooks/useIsSmallScreen";
import { useStudios } from "../../redux/dicts/hooks";
import { useSiteBanner } from "../../redux/site/hooks/useSiteBanner";
import { useSiteContacts } from "../../redux/site/hooks/useSiteContacts";
import { useSiteGallery } from "../../redux/site/hooks/useSiteGallary";
import { useSiteNews } from "../../redux/site/hooks/useSiteNews";
import { navbarHeight } from "../../theme";
import BannerItem from "./components/BannerItem";
import FooterContainer from "./components/FooterContainer";
import FooterItem from "./components/FooterItem";
import GalleryCardItem from "./components/GalleryCardItem";
import GalleryContainer from "./components/GalleryContainer";
import NewsCard from "./components/NewsCard";
import NewsCardSkeleton from "./components/NewsCardSkeleton";
import SectionHeader from "./components/SectionHeader";
import StudioCard from "./components/StudioCard";
import StudioCardSkeleton from "./components/StudioCardSkeleton";

const viewportSections = {
    news: {
        small: 1,
        large: 3,
    },
    gallery: {
        small: 1,
        large: 3
    }
}


const MainPage = () => {

    const isSmallScreen = useIsSmallScreen();

    const { studios, studiosIsLoading } = useStudios();

    const [siteNews, siteNewsAreLoading, currentNewsPage, setCurrentNewsPage, pageNewsNumber] = useSiteNews(viewportSections.news);

    const [siteGallery, siteGalleryIsLoading, currentGalleryPage, setCurrentGalleryPage, pageGalleryNumber] = useSiteGallery(viewportSections.gallery);

    const [siteContacts] = useSiteContacts();

    const [banners, bannersAreLoading] = useSiteBanner();

    const screenHeight = React.useRef(window.innerHeight);

    return <Box sx={{ background: "white" }}>
        <Carousel
            interval={4000}
            sx={{ marginTop: `${navbarHeight}px` }}
            height={screenHeight.current - navbarHeight}
            stopAutoPlayOnHover={true}
            animation="slide"
            autoPlay={true}
            duration={700}
        >
            {!bannersAreLoading ? (
                banners.map((item, i) => <BannerItem key={i} item={item} size={screenHeight.current - navbarHeight} />)
            ) : (
                <BannerItem
                    key={0}
                    item={{
                        // header: "Placeholder",
                        // text: "Placeholder",
                        image: "/public/static/images/placeholderBanner.png"
                    }}
                />
            )}
        </Carousel>

        <Box sx={{ width: { lg: 1200, md: "100%" }, m: "auto" }}>

            <SectionHeader id="studios" text="Студии" />

            <Grid container spacing={3} justifyContent="center" sx={{ p: 4 }}>
                {!studiosIsLoading ? (
                    studios.map((element, _) => <StudioCard
                        key={element.id}
                        name={element.name}
                        description={element.info}
                        duration={element.duration}
                        image={element.image}
                    />)
                ) : (
                    Array(7).fill(null).map((_, index) => <StudioCardSkeleton key={index} />)
                )}
            </Grid>

            <SectionHeader id="news" text="Новости" />

            <Grid container spacing={3} justifyContent="center" sx={{ p: 4 }}>
                {/* // {siteNewsAreLoading && siteNews.length === 0 ? ( */}
                {siteNewsAreLoading ? (
                    Array(isSmallScreen ? viewportSections.news.small : viewportSections.news.large).fill(null).map(
                        (_, index) => <NewsCardSkeleton key={index} />
                    )
                ) : (
                    siteNews.map((element, _) => <NewsCard
                        key={element.id}
                        header={element.header}
                        image={element.image}
                        text={element.text}
                    />)
                )}
            </Grid>

            <Box mt={3} sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <Pagination
                    defaultPage={1}
                    page={currentNewsPage}
                    size="medium"
                    count={pageNewsNumber}
                    onChange={(_, value) => setCurrentNewsPage(value)}
                />
            </Box>

            <SectionHeader id="gallery" text="Галерея" />

            <GalleryContainer>
                {!siteGalleryIsLoading ? (
                    siteGallery.map((item) => <GalleryCardItem key={item.id} item={item} />)
                ) : (
                    Array(isSmallScreen ? viewportSections.gallery.small : viewportSections.gallery.large)
                        .fill(null).map((_, index) => <Skeleton
                            key={index}
                            variant="rounded"
                            width="100%"
                            height="450px"
                        />)
                )}
            </GalleryContainer>

            <Box mt={4} sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                <Pagination
                    defaultPage={1}
                    page={currentGalleryPage}
                    size="medium"
                    count={pageGalleryNumber}
                    onChange={(_, value) => setCurrentGalleryPage(value)}
                />
            </Box>
        </Box>

        <FooterContainer>
            {siteContacts?.map((item) => <FooterItem key={item.id} item={item} />)}
        </FooterContainer>
    </Box>
}

export default MainPage